// 全局状态
export const globalStatus= {
  // 暂时没用到
  serverError: 'serverError',
  // 在线
  online: 'online',
}


// WEBPACK FOOTER //
// ./src/types/index.js